import { Controller } from "@hotwired/stimulus"
import PusherManager from "../services/pusher_manager"
import { turboFetch } from "../util/common"

export default class extends Controller {
  static values = {
    chatId: Number,
    refreshUrl: String
  }

  connect() {
    this.handleChatCloseToggle = this.handleChatCloseToggle.bind(this)
    this.handleChatArchiveToggle = this.handleChatArchiveToggle.bind(this)

    if (!PusherManager.isInitialized()) {
      PusherManager.initialize()
    }

    PusherManager.subscribeToChatCloseToggle(this.chatIdValue, this.handleChatCloseToggle)
    PusherManager.subscribeToChatArchiveToggle(this.chatIdValue, this.handleChatArchiveToggle)
  }

  disconnect() {
    PusherManager.unsubscribe(this.handleChatCloseToggle)
    PusherManager.unsubscribe(this.handleChatArchiveToggle)
  }

  handleChatCloseToggle(event) {
    if (event.chatId !== this.chatIdValue)
      return

    this.refresh()
  }

  handleChatArchiveToggle(event) {
    if (event.chatId !== this.chatIdValue)
      return

    this.refresh()
  }

  refresh() {
    turboFetch(this.refreshUrlValue, { method: "GET" })
  }
}
